// extracted by mini-css-extract-plugin
module.exports = {"urlTrackLink":"style_urlTrackLink__pbiuA","arrowIcon":"style_arrowIcon__NV8P4","urlTrack":"style_urlTrack__70lvU","link":"style_link__7P6KY","linkActive":"style_linkActive__Fys_5"};